class ProductRecommendations extends HTMLElement {
  constructor() {
    super()
    this.recommendUrl = this.getAttribute('data-url')
    this.recommendationContainer = this.querySelector(
      '[data-recommendations-container]',
    )
    this.loadRecommendations()
  }

  loadRecommendations() {
    fetch(this.recommendUrl)
      .then((response) => response.text())
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html')
        const recommendedContent = html.querySelector(
          '[data-recommendations-container]',
        )
        if (recommendedContent) {
          this.recommendationContainer.innerHTML = recommendedContent.innerHTML
        }

        const cards =
          this.recommendationContainer.querySelectorAll('nova-product-card')
        for (const card of cards) {
          const optionValuesTemplate =
            this.recommendationContainer.querySelector(
              `#options-json-${card.id}`,
            )
          const variantsTemplate = this.recommendationContainer.querySelector(
            `#variants-json-${card.id}`,
          )
          const productOptions = optionValuesTemplate
            ? JSON.parse(optionValuesTemplate.content.textContent.trim())
            : []
          const variants = variantsTemplate
            ? JSON.parse(variantsTemplate.content.textContent.trim())
            : []
          card.productOptions = productOptions.filter(
            (item) => item.name !== 'Title',
          )
          card.variants = variants
        }

        document.dispatchEvent(new CustomEvent('nova:product-carousel-loaded'))

        setTimeout(() => {
          document.dispatchEvent(new CustomEvent('swym:collections-loaded'))
        }, 100)
      })
  }
}

customElements.define('nova-product-recommendations', ProductRecommendations)
